import {GenericModel} from '../shared/model/generic.model';

export class DashboardResumoFinanceiro {

	public data:string;

	public valorVendas:number;

	public valorCompras:number;

	public valorDuplicatasReceber:number;

	public valorDuplicatasPagar:number;
}

export class Dashboard extends GenericModel {

    public valorVendas:number;
	
	public valorCompras:number;
	
	public valorDuplicatasReceber:number;

	public valorDuplicatasPagar:number;

	public valorVendasAnterior:number;

	public valorComprasAnterior:number;

	public valorDuplicatasReceberAnterior:number;

	public valorDuplicatasPagarAnterior:number;

	public percentualVendas:number;

	public percentualCompras:number;

	public percentualDuplicatasReceber:number;

	public percentualDuplicatasPagar:number;

	public resumoFinanceiro:DashboardResumoFinanceiro[];
}
